module.exports = __webpack_public_path__ + "img/Middle-Bevel-Attachment-44.0f8b9bd4.png";